import { apiFetch } from './api';

/** La convocation et la réponse déjà donnée, par jeton (page publique). */
export function getPresence(token) {
  return apiFetch(`/presence/${token}`);
}

/** Répondre à une convocation : 'present' ou 'absent', avec un mot facultatif. */
export function repondrePresence(token, reponse, commentaire = null) {
  return apiFetch(`/presence/${token}`, {
    method: 'POST',
    body: JSON.stringify({ reponse, commentaire }),
  });
}
